import { useState, useEffect } from "react";

/**
 * Custom hook for detecting mobile viewport
 * @param breakpoint - Width breakpoint for mobile detection (default: 768)
 * @returns boolean - True if viewport is below breakpoint
 */
export function useIsMobile(breakpoint = 768): boolean {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth < breakpoint);

        // Initial check
        checkMobile();

        // Add resize listener
        window.addEventListener('resize', checkMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkMobile);
    }, [breakpoint]);

    return isMobile;
}

export default useIsMobile;
